const removeFromLocalStorage = (key) => {
    try {
        localStorage.removeItem(key);
    } catch(e) {
        return false;
    }
}

export default removeFromLocalStorage;